// @flow
import { createFuzzySearchImpl, fuzzyMatchImpl } from "./impl";
export const createFuzzySearch = (list, options = {}) => createFuzzySearchImpl(list, options);
export const fuzzyMatch = (text, queryText) => fuzzyMatchImpl(text, queryText);
export { default as normalizeText } from './normalizeText';
